import {ApiClient} from '@hconnect/apiclient'
import {EquipmentData} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

const ITEMS_PER_RESPONSE = 100

export const useMainEquipmentNumberSearchQuery = (
  plantId: string,
  searchTerm: string | undefined,
  options?: Omit<UseQueryOptions<EquipmentData[], AxiosError>, 'queryKey'>
) => {
  const {
    i18n: {language}
  } = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  return useQuery<EquipmentData[], AxiosError>({
    queryKey: ['mainEquipmentNumberSearch', searchTerm, language, plantId],
    queryFn: async () => {
      const path = `/plantconfig/${plantId}/mainequipmentnumbers`
      const params = {
        params: {
          searchPattern: searchTerm,
          itemsPerResponse: ITEMS_PER_RESPONSE,
          language
        }
      }

      const response = await ApiClient.axiosInstance.get<EquipmentData[]>(path, params)
      return response.data
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  })
}
